// ----------------------------------------------------------------------

export const MAX_ATTACHMENTS = 1;
export const MAX_ATTACHMENT_SIZE = 10 * 1024 * 1024; // 10MB — matches Bedrock Converse per-file limits

// Accepted by react-dropzone's `accept` option (mime type -> extra extensions).
export const ACCEPTED_ATTACHMENT_TYPES = {
  'application/pdf': [],
  'text/csv': [],
  'text/plain': [],
  'text/markdown': ['.md'],
  'text/html': [],
  'application/msword': [],
  'application/vnd.ms-excel': [],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
};

// Reads a File as base64 (without the `data:...;base64,` prefix) for the JSON attachments payload.
export function fileToAttachmentPayload(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = String(reader.result).split(',')[1] || '';
      resolve({
        name: file.name,
        contentType: file.type || 'application/octet-stream',
        size: file.size,
        data: base64,
      });
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
